import { createStore } from 'vuex';
import vuexPersistedState from 'vuex-persistedstate';

export default createStore({
  state: {
    user: {
      age: null,
      weight: null,
      height: null,
      gender: null,
      ethnicity: null,
      rol:null
    },
  },
  getters: {
    user: (state) => state.user,
  },
  mutations: {
    setUserData(state, userData) {
      state.user = userData;
    },
  },
  actions: {
    setUserData({ commit }, userData) {
      commit('setUserData', userData);
    },
  },
  plugins: [
    vuexPersistedState({
      key: 'user', // La clave que se usará en localStorage
      paths: ['user'], // Persistir todo el objeto 'user'
    }),
  ],
  modules: {
  }
});
